import useGoToHome from '../../../common/hooks/useGoToHome';
import useUserContext from '../../../common/hooks/useUserContext';

function UserSecurityQuestions() {
  const { user, dispatch } = useUserContext();
  useGoToHome();
  if (user.UserJustAnsweredSecurityQuestion) {
    dispatch({ type: 'USER_ANSWERED_SECURITY_QUESTIONS' });
  }
  return null;
}

export default UserSecurityQuestions;
